/* Mobile swipe slider (matches lens-tech-modal nav style) */
;(() => {
  const MOBILE_MAX = 749
  const mq = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`)

  const cleanupMap = (window.__tourCitiesCleanup = window.__tourCitiesCleanup || new Map())

  const ensureNav = (wrap) => {
    if (!wrap) return null

    const existingPrev = wrap.querySelector('.tcNav--prev')
    const existingNext = wrap.querySelector('.tcNav--next')
    if (existingPrev && existingNext) return { prevBtn: existingPrev, nextBtn: existingNext }

    const mkBtn = (cls, label, dir) => {
      const b = document.createElement('button')
      b.type = 'button'
      b.className = `tcNav ${cls}`
      b.setAttribute('aria-label', label)
      b.dataset.dir = String(dir)
      b.hidden = true
      b.disabled = true

      b.innerHTML =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M14.5 5.5L8 12l6.5 6.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
        '</svg>'

      if (dir > 0) b.querySelector('path').setAttribute('d', 'M9.5 5.5L16 12l-6.5 6.5')
      return b
    }

    const prevBtn = mkBtn('tcNav--prev', 'Previous', -1)
    const nextBtn = mkBtn('tcNav--next', 'Next', 1)

    wrap.appendChild(prevBtn)
    wrap.appendChild(nextBtn)

    return { prevBtn, nextBtn }
  }

  const initSection = (root) => {
    if (!root) return

    const sectionId = root.getAttribute('data-section-id') || ''
    const prevCleanup = cleanupMap.get(sectionId)
    if (typeof prevCleanup === 'function') prevCleanup()

    const swipeEnabled = (root.getAttribute('data-tc-swipe') || 'false') === 'true'
    const mobileWrap = root.querySelector('[data-tc-mobile]')
    const slider = root.querySelector('[data-tc-slider]')
    const slides = slider ? Array.from(slider.querySelectorAll('[data-tc-slide]')) : []

    if (!mobileWrap || !slider || !slides.length) {
      cleanupMap.set(sectionId, () => {})
      return
    }

    let navState = null
    let onScroll = null
    let onResize = null
    let onMq = null

    const setBothHidden = (prevBtn, nextBtn) => {
      prevBtn.hidden = true
      nextBtn.hidden = true
      prevBtn.disabled = true
      nextBtn.disabled = true
    }

    const getGap = () => {
      const styles = window.getComputedStyle(slider)
      return parseFloat(styles.columnGap || styles.gap || '0') || 0
    }

    const getScrollAmount = () => {
      const first = slides[0]
      if (first) return first.getBoundingClientRect().width + getGap()
      return Math.max(240, Math.floor(slider.clientWidth * 0.85))
    }

    const getPad = () => {
      const styles = window.getComputedStyle(slider)
      const pl = parseFloat(styles.paddingLeft || '0') || 0
      const pr = parseFloat(styles.paddingRight || '0') || 0
      return { pl, pr }
    }

    const updateButtons = () => {
      if (!navState) return
      const { prevBtn, nextBtn } = navState

      if (!mq.matches || !swipeEnabled) {
        setBothHidden(prevBtn, nextBtn)
        return
      }

      const maxScroll = slider.scrollWidth - slider.clientWidth
      if (maxScroll <= 2) {
        setBothHidden(prevBtn, nextBtn)
        return
      }

      const pad = getPad()
      const current = slider.scrollLeft

      const startThreshold = pad.pl + 2
      const endThreshold = maxScroll - pad.pr - 2

      const atStart = current <= startThreshold
      const atEnd = current >= endThreshold

      prevBtn.disabled = atStart
      nextBtn.disabled = atEnd
      prevBtn.hidden = atStart
      nextBtn.hidden = atEnd
    }

    const attach = () => {
      if (!mq.matches || !swipeEnabled) return

      navState = ensureNav(mobileWrap)
      if (!navState) return

      const { prevBtn, nextBtn } = navState

      const scrollByDir = (dir) => {
        slider.scrollBy({ left: getScrollAmount() * dir, behavior: 'smooth' })
      }

      prevBtn.addEventListener('click', () => scrollByDir(-1))
      nextBtn.addEventListener('click', () => scrollByDir(1))

      onScroll = () => updateButtons()
      onResize = () => updateButtons()

      slider.addEventListener('scroll', onScroll, { passive: true })
      window.addEventListener('resize', onResize, { passive: true })

      window.setTimeout(updateButtons, 50)
      window.setTimeout(updateButtons, 300)
    }

    const detach = () => {
      if (!navState) return
      const { prevBtn, nextBtn } = navState

      if (onScroll) slider.removeEventListener('scroll', onScroll)
      if (onResize) window.removeEventListener('resize', onResize)

      setBothHidden(prevBtn, nextBtn)
    }

    const rebuild = () => {
      detach()
      attach()
      updateButtons()
    }

    attach()

    onMq = () => rebuild()
    if (mq.addEventListener) mq.addEventListener('change', onMq)
    else mq.addListener(onMq)

    cleanupMap.set(sectionId, () => {
      detach()
      if (mq.removeEventListener) mq.removeEventListener('change', onMq)
      else mq.removeListener(onMq)
    })
  }

  const initAll = () => {
    document.querySelectorAll('[data-tc-section]').forEach(initSection)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true })
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target && e.target.querySelector ? e.target.querySelector('[data-tc-section]') : null
    initSection(root)
  })

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target && e.target.querySelector ? e.target.querySelector('[data-tc-section]') : null
    if (!root) return

    const sectionId = root.getAttribute('data-section-id') || ''
    const prevCleanup = cleanupMap.get(sectionId)
    if (typeof prevCleanup === 'function') prevCleanup()
    cleanupMap.delete(sectionId)
  })
})()